import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useModuleNode from '../_MODULE/useModuleNode.jsx'
import api from './apiPm.mjs'
import meta from './metaPm.mjs'
import Model from './ModelPm.mjs'
import PropertiesPane from './PropertiesPanePm.jsx'

export default () => {
    const ModuleNode = useModuleNode()

    return extendNode(ModuleNode, {
        ...meta,
        api,
        Model,
        PropertiesPane,

        getStyle(map, node) {
            const {subTypeCode} = map.data

            const borderColor = 'BODA1' === subTypeCode ?
                Color.GOLD : Color.LIGHT_YELLOW

            return this._getStyle(map, node, {borderColor})
        },

        async _atOwnerPush(map, node, event) {
            const {bizNodeType} = event.target.data

            const key = {
                PA: 'archPmList',
                PM: 'child'
            }[bizNodeType]

            const d = await this._getPushData(map, node)
            event.detail[key].push(d)
        },
    })
}
